import React from "react";
import { Link } from "react-router-dom";

export const Home = () => {
    document.title = "Ana səhifə";

    return (
        <div>
            <div className="container">
                <h1 className="my-4">Başlıqlar</h1>
                <div className="row g-4">
                    <div className="col-6">
                        <Link to={"dashboard"}>Göstəricilər</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"/products"}>Məhsullar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"supplies"}>Alışlar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"demands"}>Satışlar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"customers"}>Tərəf müqabillər</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"finance"}>Maliyyə</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"expeditors"}>Distributorlar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"cash"}>Kassa</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"reports"}>Hesabatlar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"settings"}>Ayarlar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"common"}>Ümumi anlayışlar</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
